var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-paddings"},[_c('b-container',{staticClass:"pt-5 pt-lg-5 wrapper pb-5"},[_c('div',{staticClass:"pt-5 news-header text-center d-flex flex-column justify-content-center mt-sm-1-custom"},[_c('h4',[_vm._v(_vm._s(_vm.$t("website.news.title")))])]),_c('News')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }